// extracted by mini-css-extract-plugin
export default {"container":"EventAttachModal_container__J+oYc"};